<template>
  <v-dialog
    :value="advancedSearchDialog"
    persistent
    scrollable
    content-class="add-edit-dialog advanced-search-dialog"
    @keydown.enter="submit">
    <v-card>
      <v-toolbar 
        class="escalon-dialog-header" 
        height="35"
        :style="borderStyle">
        <img
          class="modal-axis-logo mr-2"
          :src="require('../../assets/' + coloredLogo)" />
        <span>Advanced Search</span>
        <v-spacer />
        <v-btn text @click="closeAdvancedSearch">
          <v-avatar size="20" class="mr-2">
            <img :src="require('../../assets/' + coloredAssetUrls.close)" />
          </v-avatar>Close
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="valid" @submit.prevent="submit">
          <h2 class="add-edit-modal-header">SEARCH CRITERIA</h2>
          <v-container fluid grid-list-md>
            <v-layout wrap>
              <v-flex md4>
                <div>
                  <label class="modal-label">Patient Name</label>
                </div>
                <v-text-field
                  type="text"
                  v-model="advancedSearch.patientName"
                  name="advancedSearch.patientName"
                  data-vv-as="advancedSearch.patientName"
                  solo/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Patient ID</label>
                </div>
                <v-text-field
                  type="text"
                  v-model="advancedSearch.patientID"
                  name="advancedSearch.patientID"
                  data-vv-as="advancedSearch.patientID"
                  solo/>
              </v-flex>
                <v-flex md4>
                <div>
                  <label class="modal-label">Patient DOB</label>
                </div>
                <date-menu
                  :value="advancedSearch.dob"
                  @change="setDateDOB"
                  v-validate="'date'"
                  name="advancedSearch.dob"
                  data-vv-as="DOB"
                  :error-messages="errors.collect('advancedSearch.dob')"
                  solo/>
                </v-flex>
              <v-flex md12>
                <div>
                  <label class="modal-label">Exam Date Range</label>
                </div>
                <v-layout>
                  <v-flex md4>
                    <div>
                      <label class="modal-label">From</label>
                    </div>
                    <date-menu
                      :value="advancedSearch.date.from"
                      @change="setDateFrom"
                      v-validate="'date'"
                      name="advancedSearch.date.from"
                      data-vv-as="From"
                      :error-messages="errors.collect('advancedSearch.date.from')"
                      solo/>
                  </v-flex>
                  <v-flex md4>
                    <div>
                      <label class="modal-label">To</label>
                    </div>
                    <date-menu
                      :value="advancedSearch.date.to"
                      @change="setDateTo"
                      v-validate="'date'"
                      name="advancedSearch.date.to"
                      data-vv-as="To"
                      :error-messages="errors.collect('advancedSearch.date.to')"
                      solo/>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Exam Type</label>
                </div>
                <select-with-button
                  class="select-btn"
                  v-model="advancedSearch.device"
                  :items="sortedDevices"
                  name="advancedSearch.device"
                  data-vv-as="advancedSearch.device"
                  multiple/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Physician</label>
                </div>
                <select-with-button
                  class="select-btn"
                  v-model="advancedSearch.physicians"
                  :items="sortedPhysicians"
                  name="advancedSearch.physicians"
                  data-vv-as="advancedSearch.physicians"
                  multiple/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Diagnosis</label>
                </div>
                <v-text-field
                  type="text"
                  v-model="advancedSearch.examPathology"
                  name="advancedSearch.examPathology"
                  data-vv-as="advancedSearch.examPathology"
                  solo/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Dictated</label>
                </div>
                <select-with-button
                  class="select-btn"
                  v-model="advancedSearch.dictated"
                  :items="dictated"
                  name="advancedSearch.dictated"
                  data-vv-as="advancedSearch.dictated"/>
              </v-flex>
              <v-flex md4>
                <div>
                  <label class="modal-label">Teaching/Research Case</label>
                </div>
                <select-with-button
                  class="select-btn"
                  v-model="advancedSearch.teaching"
                  :items="teaching"
                  name="advancedSearch.teaching"
                  data-vv-as="advancedSearch.teaching"/>
              </v-flex>
              <v-flex md1.5>
                <div>
                  <label class="modal-label">Search Operator</label>
                </div>
                <v-radio-group
                  v-model="advancedSearch.searchOP"
                  :mandatory="true"
                  name="advancedSearch.searchOP"
                  data-vv-as="advancedSearch.searchOP"
                  row>
                  <v-radio label="AND"
                    value="and"
                    style="margin-bottom: 0;"
                    :color="colorHex" />
                  <v-radio label="OR"
                    value="or"
                    :color="colorHex" />
                </v-radio-group>
              </v-flex>
              <v-flex md2.2 align-self-center>
                <v-row class="justify-end">
                  <v-card-actions>
                    <v-btn text @click="closeAdvancedSearch" class="modal-cta">Cancel</v-btn>
                    <image-button
                      btnClass="modal-cta"
                      title="Clear"
                      :image="coloredAssetUrls.reset"
                      @click="clear"
                      text/>
                    <v-btn text @click="submit" class="modal-cta">Search</v-btn>
                  </v-card-actions>
                </v-row>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>
<script>
import selectWithButton from "../../components/controls/SelectWithButton";
import dateMenu from "../../components/controls/DateMenu";
import imageButton from "../controls/ImageButton";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "advancedSearch",
  components: {
    selectWithButton,
    imageButton,
    dateMenu
  },
  props: {
    isPass: Boolean,
    patient: Object,
    files: Array,
    upload: Object,
    isEditing: Boolean,
    isAdding: Boolean,
    exam: Object
  },
  data() {
    return {
      dictated: [{ value: true, text: "Yes" }, { value: false, text: "No" }],
      teaching: [{ value: true, text: "Yes" }, { value: false, text: "No" }],
      advancedSearch: {
        patientName: "",
        patientID: "",
        dob: "",
        date: {
          from: "",
          to: ""
        },
        device: [],
        physicians: [],
        examPathology: "",
        dictated: null,
        teaching: null,
        searchOP: "and"
      },
      valid: false
    };
  },
  computed: {
    ...mapGetters(["advancedSearchDialog", "devices", "physicians"]),
    sortedDevices() {
      return [...this.devices]
        .sort((a, b) =>
          a.procedure < b.procedure
            ? -1
            : a.procedure > b.procedure
            ? 1
            : 0
        )
        .map(d => {
          return { value: d, text: d.procedure };
        });
    },
    sortedPhysicians() {
      return [...this.physicians]
        .sort((a, b) => {
          let nA = a.name.toLowerCase(),
            nB = b.name.toLowerCase();
          return nA < nB ? -1 : nA > nB ? 1 : 0;
        })
        .map(p => {
          return { value: p, text: p.name };
        });
    }
  },
  methods: {
    // todo - any validation rules to trigger on submit?
    // we have data-vv-as attributes, but no validation rules
    ...mapMutations(["closeAdvancedSearch"]),
    ...mapActions(["submitAdvancedSearch"]),
    submit(){
      this.$validator
        .validateAll()
        .then(valid => {
          if (!valid) return Promise.reject("Please fix all form errors");
          return Promise.resolve();
        }).then(() => this.submitAdvancedSearch(this.advancedSearch))
        .catch(msg => {
          this.$store.commit("displayStatus", { message: msg, level: "error" });
        });
    },
    clear() {
      this.advancedSearch.patientName = "";
      this.advancedSearch.patientID = "";
      this.advancedSearch.dob = "";
      this.advancedSearch.date.to = "";
      this.advancedSearch.date.from = "";
      this.advancedSearch.device = [];
      this.advancedSearch.physicians = [];
      this.advancedSearch.examPathology = "";
      this.advancedSearch.dictated = null;
      this.advancedSearch.teaching = null;
      this.advancedSearch.searchOP = "and";
    },
    setDateFrom(value){
      this.$set(this.advancedSearch.date, "from", value);
    },
    setDateTo(value){
      this.$set(this.advancedSearch.date, "to", value);
    },
    setDateDOB(value){
      this.$set(this.advancedSearch, "dob", value);
    },
  }
};
</script>